import { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './SmallModal.module.css'
import { getIcon, IconName } from '../icons/utils'
import { Modal } from './Modal'
import { CloseButton } from '../button/CloseButton'
import { Button } from '../button/Button'
import { useTrapFocus } from '../../../hooks/useTrapFocus'
import classNames from 'classnames'

type SmallModalProps = {
  onClose: () => void
  headerText: string
  sendButtonText?: string
  onSubmit?: () => void
  allowSubmitting?: boolean
  iconName?: IconName
  sendButtonIsSubmit?: boolean
  hideSendButton?: boolean
  hideCancelButton?: boolean
}

export const SmallModal: React.FC<PropsWithChildren<SmallModalProps>> = ({
  onClose,
  headerText,
  sendButtonText,
  onSubmit,
  allowSubmitting = true,
  iconName,
  sendButtonIsSubmit = false,
  hideSendButton = false,
  hideCancelButton = false,
  children,
}) => {
  const modalRef = useTrapFocus<HTMLDivElement>()
  const { t } = useTranslation()

  return (
    <Modal>
      <div className={styles.modalContainerSticky}>
        <div ref={modalRef} className={styles.modalContainer}>
          <div className={styles.modalTop}>
            <div className={styles.modalTopInfo}>
              {iconName && <div className={styles.modalTopIcon}>{getIcon(iconName)}</div>}
              <div className={styles.modalTopText}>{headerText}</div>
            </div>
            <CloseButton autoFocus onClick={onClose} tabIndex={0} />
          </div>
          <div className={styles.modalContent}>{children}</div>
          <div className={classNames(styles.modalFooter, hideCancelButton && styles.noCancelButton)}>
            {!hideCancelButton && (
              <Button variant='outline-normal' onClick={onClose} tabIndex={0}>
                {t('common.cancel', 'Cancel')}
              </Button>
            )}
            {!hideSendButton && (
              <Button
                type={sendButtonIsSubmit ? 'submit' : 'button'}
                disabled={!allowSubmitting}
                tabIndex={0}
                onClick={onSubmit}
              >
                {sendButtonText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}
